// PLUGINS IMPORTS //
import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components/macro"

// COMPONENTS IMPORTS //
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  title: string
  icon: string

  linkDest: string
}

const MenuButton: React.FC<PropsType> = (props) => {
  return (
    <Wrapper id={"nav-item"}>
      <Link
        to={props.linkDest || `/${props.title.toLocaleLowerCase()}`}
        // @ts-ignore
        style={styles.link}
      >
        <img src={props.icon} />
        {props.title}
      </Link>
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const MARGIN_HORIZONTAL = "15px"
const Wrapper = styled.div`
  color: rgba(255, 255, 255, 0.7);
  padding: 10px;
  margin-left: ${MARGIN_HORIZONTAL};
  margin-right: ${MARGIN_HORIZONTAL};
  transition: 0.3s ease-out;
  border-radius: 10px;
  cursor: pointer;

  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1),
    inset 0px 0px 0px 0.5px rgba(255, 255, 255, 0.2);

  img {
    margin-right: 10px;
  }

  :hover {
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1),
      inset 0px 0px 0px 0.5px rgba(255, 255, 255, 0.2);
  }

  @media (max-width: 768px) {
    display: none;
  }
`

const styles = {
  link: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
}

export default React.memo(MenuButton, memoComparison)
